import { render, staticRenderFns } from "./MtgAbilities.vue?vue&type=template&id=02546ba8"
import script from "./MtgAbilities.vue?vue&type=script&lang=ts"
export * from "./MtgAbilities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports